import { FormControl, FormControlLabel, Radio, RadioGroup } from '@material-ui/core'
import { editUserAttribute } from 'lib/api'
import { useOnboardingStore } from 'lib/hooks/useOnboardingStore'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ONBOARDING_STEPS } from 'shared'
import { COMMENTS_QUESTIONNAIRE } from 'utils/constants'

export interface OnboardingCommentsFormProps {
  setVisitedSteps: (value: React.SetStateAction<number[]>) => void
}

export const CommentsForm = ({ setVisitedSteps }: OnboardingCommentsFormProps): JSX.Element => {
  const { t } = useTranslation()
  const { setOnboardingStep } = useOnboardingStore()
  const [checked, setChecked] = useState<boolean | null>(null)

  const handleChange = async (e: any) => {
    const isChecked = e.target.value === 'true'
    setChecked(isChecked)

    const answer = {
      [COMMENTS_QUESTIONNAIRE[0].code]: isChecked,
    }

    await editUserAttribute(answer, 'stockCommentsSurvey')

    if (isChecked) {
      setOnboardingStep(ONBOARDING_STEPS.CONTACTS_FOR_HELP.idx)
      setVisitedSteps((prev) => [...prev, ONBOARDING_STEPS.CONTACTS_FOR_HELP.idx])
    } else {
      setOnboardingStep(ONBOARDING_STEPS.SET_PRICES.idx)
      setVisitedSteps((prev) => [...prev, ONBOARDING_STEPS.SET_PRICES.idx])
    }
  }

  const question = COMMENTS_QUESTIONNAIRE[0]

  return (
    <div className="d-flex justify-content-center w-100 onboarding-container">
      <div className="wizard-content mt-lg-5 container">
        <h3 className="fw-normal">{t('onboarding.commentsToTagStock')}</h3>
        <div className="d-flex flex-column">
          <div className="mb-3 py-1">
            <FormControl>
              <p className="fs-6 m-0 p-0 fw-light">
                {t(`onboarding.commentsQuestionnaire.${question.label}`)}
              </p>
              <p className="m-0 p-0 fw-light">
                {t(`onboarding.commentsQuestionnaire.${question.example}`)}
              </p>
              <RadioGroup>
                <FormControlLabel
                  checked={checked === true}
                  value="true"
                  control={<Radio />}
                  label="Yes"
                  onChange={(e) => handleChange(e)}
                  data-testid="check-true"
                  disabled={checked !== null}
                />
                <FormControlLabel
                  checked={checked === false}
                  value="false"
                  control={<Radio />}
                  label="No"
                  onChange={(e) => handleChange(e)}
                  data-testid="check-false"
                  disabled={checked !== null}
                />
              </RadioGroup>
            </FormControl>
          </div>
        </div>
      </div>
    </div>
  )
}
